<template>
    <div id="order-finish-delivered">
        <div v-if="orderNo" class="order-not">没有该状态订单</div>
        <div v-else class="order-list">
            <div
                v-for="(item, index) in orderNotDeliveredData"
                :key="index"
                class="order-card"
                @click="orderDetail(item.id, item.orderStatus, item.orderType)"
            >
                <div class="order-card-main">
                    <div class="order-card-icon-wrap">
                        <img class="order-card-icon" src="@/assets/order.png" alt="订单图标">
                    </div>
                    <div class="order-card-body">
                        <div class="order-card-header">
                            <div class="order-card-title">订单编号：<span class="order-card-no">{{item.orderNumber}}</span></div>
                            <img class="order-card-arrow" src="@/assets/common_next.png" alt="箭头">
                        </div>
                        <div class="order-card-meta">
                            <span class="order-card-label">下单时间：</span>
                            <span class="order-card-value">{{item.orderTime}}</span>
                        </div>
                        <div class="order-card-meta">
                            <span class="order-card-label">已配送时间：</span>
                            <span class="order-card-value">{{item.deliveryTime}}</span>
                        </div>
                        <div class="order-card-meta">
                            <span class="order-card-label">订单状态：</span>
                            <span class="order-card-status">{{item.orderStatus}}</span>
                        </div>
                        <div v-if="item.addPurchaseGoods" class="order-card-meta">
                            <span class="order-card-label">加购商品：</span>
                            <span class="order-card-value">{{item.addPurchaseGoods}}</span>
                        </div>
                        <div class="order-card-footer">
                            <div class="order-type" v-if="item.orderType === 1">加价购订单</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {parseTime} from "@/unitls";
import {ListOrderPackageAndNormal} from "../../../api/PackagePeriodOrder";

export default {
        name: "OrderNotDelivered",

        data() {
            return {
                orderNotDeliveredData: [],
                orderNo: true,
            }
        },

        mounted() {
            this.requestOrderList();
        },

        methods: {
            requestOrderList(){
            ListOrderPackageAndNormal(
                {
                  orderStatus: this.$ORDER_STATUS.DELIVERED,
                  page: 0,
                  limit: -1
                }
            )
                .then((response) => {
                  if (response.code === this.$API_CODE.OK) {

                    this.orderNotDeliveredData = [];

                    response.data.packagePeriodOrderList.forEach((item) => {
                      this.orderNo = false;
                      this.orderNotDeliveredData.push({
                        id: item.id,
                        orderNumber: item.orderNumber,
                        orderTime: parseTime(item.createdAt),
                        cancelTime: parseTime(item.cancelledAt),
                        deliveryTime: parseTime(item.deliveryAt),
                        finishTime: parseTime(item.finishedAt),
                        orderStatus: this.formatStatus(item.orderStatus),
                        orderType: item.orderType,
                        addPurchaseGoods: item.addPurchaseGoods
                      })
                    });
                  }
                });
          },

            formatStatus(value) {
                return value === this.$ORDERS_STATUS.NO_DELIVERY ? '未配送' : value === this.$ORDERS_STATUS.DELIVERED ? '已配送' : value === this.$ORDERS_STATUS.FINISHED ? '已完成' : value === this.$ORDERS_STATUS.CANCELLED ? '已取消'  :  '未配送';

            },

            orderDetail(orderId, status, orderType) {
              if(orderType === 1){
                this.$router.push({path: '/PackagePeriodOrderDetail', query:{orderId, status}})
              }else{
                this.$router.push({path: '/orderDetail', query:{orderId, status}})
              }
            },
        },

        activated() {
            this.requestOrderList();
        }
    }
</script>

<style scoped lang="scss">
#order-finish-delivered {
    background: #fdf9f7;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 90px;
    padding-bottom: 4.5rem;
    position: absolute;
    width: 100%;
    box-sizing: border-box;

    .order-list {
        width: 100%;
        padding-bottom: 14px;
        box-sizing: border-box;
    }

    .order-not {
        padding: 20px 16px;
        color: #8f97ab;
        font-size: 14px;
        background: rgba(255, 255, 255, 0.92);
        border-radius: 14px;
        box-shadow: 0 6px 17px rgba(43, 61, 104, 0.05);
    }

    .order-card {
        margin-bottom: 12px;
        padding: 11px 13px;
        background: rgba(255, 255, 255, 0.96);
        border-radius: 14px;
        box-shadow: 0 7px 19px rgba(43, 61, 104, 0.06);
        box-sizing: border-box;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s ease;

        &:active {
            transform: scale(0.98);
            opacity: 0.9;
        }
    }

    .order-card-main {
        display: flex;
        align-items: flex-start;
    }

    .order-card-icon-wrap {
        width: 49px;
        height: 49px;
        margin-right: 10px;
        border-radius: 12px;
        background: linear-gradient(180deg, #fff2f4 0%, #fff7f9 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .order-card-icon {
        width: 26px;
        height: 26px;
    }

    .order-card-body {
        flex: 1;
        min-width: 0;
    }

    .order-card-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 7px;
    }

    .order-card-title {
        flex: 1;
        min-width: 0;
        color: #28344d;
        font-size: 16px;
        font-weight: 600;
        line-height: 1.45;
        word-break: break-all;
    }

    .order-card-no {
        font-size: 17px;
        font-weight: 700;
    }

    .order-card-arrow {
        width: 12px;
        height: 12px;
        margin-top: 5px;
        margin-left: 8px;
        opacity: 0.55;
        flex-shrink: 0;
    }

    .order-card-meta {
        color: #9ba3b6;
        font-size: 14px;
        line-height: 1.75;
        word-break: break-all;
        margin-bottom: 4px;
    }

    .order-card-label {
        color: #a8afc0;
    }

    .order-card-value {
        color: #9199ad;
    }

    .order-card-status {
        display: inline-block;
        padding: 1px 8px;
        color: #f5445f;
        background: #fff2f4;
        border-radius: 999px;
    }

    .order-card-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 10px;
    }

    .order-type {
        padding: 4px 9px;
        color: #f5445f;
        font-size: 12px;
        line-height: 1;
        background: #fff5f6;
        border-radius: 999px;
    }
}
</style>